export interface ScheduleEventParam {
  Follow?: ScheduleEventFollow;
  TraceAppended?: ScheduleEventTraceAppended;
  RemarkAppended?: ScheduleEventRemarkAppended;
  ScoreReached?: ScheduleEventScoreReached;
  MemberLevelUp?: ScheduleEventMemberLevelUp;
}

// tslint:disable no-empty-interface
export interface ScheduleEventFollow {
  repeat?: boolean;
}
export interface ScheduleEventRemarkAppended {
  remarkId: number;
  remarkName?: string;
}
export interface ScheduleEventScoreReached {
  score: number;
}
export interface ScheduleEventMemberLevelUp {
  level: number;
  title: string;
}
export interface ScheduleEventTraceAppended {
  traceOuterType: number;
  traceOuterTypeName: string;
}
export enum ScheduleEventType {
  Follow = 1,
  RemarkAppended = 2,
  ScoreReached = 3,
  MemberLevelUp = 4,
  TraceAppended = 5,
}



export const TraceEventType = [
  // {value: 0, title: '参与暗号'},
  // {value: 1, title: '参与刮刮卡'},
  // {value: 2, title: '参与编码刮刮卡'},
  // {value: 3, title: '参与大转盘'},
  // {value: 4, title: '参与编码大转盘'},
  // {value: 5, title: '参与积分大转盘'},
  // {value: 6, title: '参与编码兑奖'},
  {value: 7, title: '领取优惠券'},
  // {value: 8, title: '填写表单'},
  // {value: 9, title: '参与微考试'},
  // {value: 10, title: '邀请有礼'},
  // {value: 11, title: '发送消息'},
  // {value: 12, title: '点击菜单'},
  // {value: 13, title: '领取会员卡'},
  // {value: 14, title: '会员卡升级'},
  // {value: 15, title: '会员卡等级变更'},
  // {value: 16, title: '签到'},
  // {value: 17, title: '线下支付'},
  {value: 18, title: '商城下单'},
  // {value: 19, title: '积分兑换'},
  {value: 20, title: '使用优惠券'},
  // {value: 21, title: '暗号开奖'},
  // {value: 22, title: '关注公众号'},
  // {value: 23, title: '取消关注公众号'},
  {value: 24, title: '预约下单'},
  {value: 25, title: '预约开单'},
  // {value: 26, title: '扫描参数二维码'},
  // {value: 27, title: '添加标签'},
];

